import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import breadcrumbimg from '../../assets/img/bg/04.jpg'

class Breadcrumbs extends Component {
    render() {
    const { breadcrumb, hideTrail } = this.props;

        return (
            <section className="breadcrumb-area" style={{ backgroundImage: "url(" + breadcrumbimg + ")" }}>
                <div className="container">
                    <div className="breadcrumb-text">
                        <h2 className="page-title">{this.props.breadcrumb.pagename}</h2>
                        <h3>¡Invierte con nosotros y haz crecer tu negocio! </h3>
                    </div>
                </div>
            </section>
        );
    }
}

export default Breadcrumbs;
